import { COMMON_COUNTRY } from './commonCountry'
import { COMMON_SERVICE_TYPE } from './commonServiceType'
import { getLabelText } from '../utils'

function createIppOfficialDocumentOption({ key, text, fileRecordType }) {
  // 官方文件的 label 和 value 都要随当前语言展示，且两者必须保持完全一致；
  // 这里统一生成同一个 fileName，避免每个枚举项重复调用 getLabelText 后出现 key/text 维护不一致。
  const fileName = key ? getLabelText({ key, text }) : text

  return {
    label: fileName,
    value: fileName,
    fileRecordType
  }
}

// IPP 官方文件下拉枚举。label/value 保持为页面展示和 fileName 保存共用的公文名称，
// fileRecordType 按后端文件记录类型固定映射：商标使用 1-24，专利新增类型从 25 开始；
// 不在业务组件里重新维护顺序，避免展示项、保存名称、接口类型三者出现错位。
const IPP_OFFICIAL_DOCUMENT_OPTIONS = [
  createIppOfficialDocumentOption({ key: 'remote.common.newApplicationSubmissionReceipt', text: '新申请递交回执', fileRecordType: 1 }),
  createIppOfficialDocumentOption({ key: 'remote.common.noticeOfReviewComments', text: '审查意见通知', fileRecordType: 2 }),
  createIppOfficialDocumentOption({ key: 'remote.common.replyReceiptOfReviewOpinion', text: '审查意见答复回执', fileRecordType: 3 }),
  createIppOfficialDocumentOption({ key: 'remote.common.noticeOfAnnouncement', text: '公告通知', fileRecordType: 4 }),
  createIppOfficialDocumentOption({ key: 'remote.intellectual.noticeOfObjection', text: '被异议通知', fileRecordType: 5 }),
  createIppOfficialDocumentOption({ key: 'remote.common.objectionReplyReceipt', text: '异议答辩回执', fileRecordType: 6 }),
  createIppOfficialDocumentOption({ key: 'remote.common.invalidityNotice', text: '被无效通知', fileRecordType: 7 }),
  createIppOfficialDocumentOption({ key: 'remote.common.invalidityDefenseReceipt', text: '无效答辩回执', fileRecordType: 8 }),
  createIppOfficialDocumentOption({ key: 'remote.enumerate.finishFileNameCertificate', text: '证书', fileRecordType: 9 }),
  createIppOfficialDocumentOption({ key: 'remote.common.applicantInfoChangeReceipt', text: '申请人信息变更回执（名称/地址变更）', fileRecordType: 10 }),
  createIppOfficialDocumentOption({ key: 'remote.common.applicantInfoChangeApprovalNotice', text: '申请人信息变更核准通知（名称/地址变更）', fileRecordType: 11 }),
  createIppOfficialDocumentOption({ key: 'remote.common.assignmentSubmissionReceipt', text: '转让递交回执', fileRecordType: 12 }),
  createIppOfficialDocumentOption({ key: 'remote.common.assignmentApprovalNotice', text: '转让核准通知', fileRecordType: 13 }),
  createIppOfficialDocumentOption({ key: 'remote.common.oathRenewalSubmissionReceipt', text: '宣誓/续展递交回执', fileRecordType: 14 }),
  createIppOfficialDocumentOption({ key: 'remote.common.oathRenewalApprovalNotice', text: '宣誓/续展核准通知', fileRecordType: 15 }),
  createIppOfficialDocumentOption({ key: 'remote.common.intentToUseEvidenceSubmissionNotice', text: '意向申请补交使用证据通知', fileRecordType: 16 }),
  createIppOfficialDocumentOption({ key: 'remote.common.intentToUseEvidenceSubmissionReceipt', text: '意向申请补交使用证据回执', fileRecordType: 17 }),
  createIppOfficialDocumentOption({ key: 'remote.common.intentToUseEvidenceApprovalNotice', text: '意向申请使用证据核准通知', fileRecordType: 18 }),
  createIppOfficialDocumentOption({ key: 'remote.common.oathSubmissionReceipt', text: '宣誓递交回执', fileRecordType: 19 }),
  createIppOfficialDocumentOption({ key: 'remote.common.oathApprovalNotice', text: '宣誓核准通知', fileRecordType: 20 }),
  createIppOfficialDocumentOption({ key: 'remote.common.renewalSubmissionReceipt', text: '续展递交回执', fileRecordType: 21 }),
  createIppOfficialDocumentOption({ key: 'remote.common.renewalApprovalNotice', text: '续展核准通知', fileRecordType: 22 }),
  createIppOfficialDocumentOption({ key: 'remote.common.cancellationNotice', text: '被撤销通知', fileRecordType: 23 }),
  createIppOfficialDocumentOption({ key: 'remote.common.cancellationDefenseReceipt', text: '撤销答辩回执', fileRecordType: 24 }),
  createIppOfficialDocumentOption({ key: 'remote.common.authorizationFeeNotice', text: '授权缴费通知', fileRecordType: 25 }),
  createIppOfficialDocumentOption({ key: 'remote.common.authorizationFeePaymentReceipt', text: '授权费缴纳回执', fileRecordType: 26 }),
  createIppOfficialDocumentOption({ key: 'remote.common.annualFeePaymentReceipt', text: '年费缴纳回执', fileRecordType: 27 }),
  createIppOfficialDocumentOption({ key: 'remote.common.priorityCopyFile', text: '优先权副本文件', fileRecordType: 28 }),
  createIppOfficialDocumentOption({ key: 'remote.common.agentChangeReceipt', text: '转代理回执', fileRecordType: 29 }),
  createIppOfficialDocumentOption({ key: 'remote.common.applicantInfoCorrectionReceipt', text: '申请人信息更正回执', fileRecordType: 30 }),
  createIppOfficialDocumentOption({ key: 'remote.common.applicantInfoCorrectionApprovalNotice', text: '申请人信息更正核准通知', fileRecordType: 31 })
]

const IPP_COUNTRY_LIST = COMMON_COUNTRY.enumArray
  .filter((item) => item.ippSort)
  .sort((a, b) => a.ippSort - b.ippSort)
  .map((item) => ({ ...item, country: item.label }))

const IPP_SERVICE_TYPE_LIST = COMMON_SERVICE_TYPE.enumArray.filter((item) => item.ippSort).sort((a, b) => a.ippSort - b.ippSort)

export { IPP_SERVICE_TYPE_LIST, IPP_COUNTRY_LIST, IPP_OFFICIAL_DOCUMENT_OPTIONS }



// WEBPACK FOOTER //
// /data/.jenkins/workspace/ost-prod/@ost/lib/enum/ippCommon.js